import React from 'react';
import { useSSR } from 'react-i18next';

interface InitI18nProps {
  initialI18nStore: any;
  initialLanguage: string;
}

const InitI18n: React.FC<InitI18nProps> = ({
  initialI18nStore,
  initialLanguage,
  children,
}) => {
  useSSR(initialI18nStore, initialLanguage);

  return <React.Fragment>{children}</React.Fragment>;
};

export default InitI18n;
